import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { TrainingAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { TrainingType } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions' | 'label' | 'onChange'> {
    onGetSuggestions?: (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
    onChange: (items: TrainingAutoCompleteDataModel[]) => void;
    label?: string;
    exceptTrainingId?: string;
    onlyActive?: boolean;
    onlyWithUserAttending?: boolean;
    isManageView?: boolean;
    isCoordinator?: boolean;
    trainingType?: TrainingType;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de treinamento.
 * @param props
 */
export const TrainingAutoComplete: React.FC<Props> = ({
    onlyActive = true,
    label = "",
    trainingType,
    onlyWithUserAttending,
    exceptTrainingId,
    isManageView = false,
    isCoordinator = false,
    onGetSuggestions, onChange, onError, ...props
}) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<TrainingAutoCompleteDataModel>>((resolve) => {
            api.v1.lmsSuggestions.trainings({
                searchText,
                pageNumber,
                pageSize,
                onlyActive: onlyActive!,
                exceptTrainingId: exceptTrainingId ?? null,
                onlyWithUserAttending: onlyWithUserAttending ?? false,
                trainingType: trainingType ?? null,
                isManageView: isManageView,
                isCoordinator: isCoordinator
            }, { signal })
                .then(result => resolve({
                    items: result.data.items as TrainingAutoCompleteDataModel[],
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            label={label}
            onError={onError}
            onGetSuggestions={onGetSuggestions ?? getSuggestions}
            onChange={items => onChange(items as TrainingAutoCompleteDataModel[])}
        />
    );
};
